(function () {
  function initTabSwitcher(root) {
    if (!root || root.dataset.tabSwitcherInit === 'true') return;
    root.dataset.tabSwitcherInit = 'true';

    var buttons = root.querySelectorAll('[data-tab-btn]');
    var panels = root.querySelectorAll('[data-tab-panel]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-btn');

        buttons.forEach(function (b) {
          var isActive = b === btn;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === target);
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-tab-switcher]').forEach(initTabSwitcher);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // 主题编辑器里新增/刷新 Section 时重新初始化
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-tab-switcher]');
    if (root) {
      root.dataset.tabSwitcherInit = 'false';
      initTabSwitcher(root);
    }
  });
})();
